module.exports = __webpack_public_path__ + "img/fireplace_comp_001_thumb.e6b79db1.jpg";